import moment from 'moment';
import React from 'react';

const MemberBasicInfo = ({ lead }) => {
	return (
		<div className='basicInfoSection'>
			<div className='individualInfos'>
				<span className='indInfoSpan'>
					<p className='infoSmallHead'>Requested on</p>
					<p className='infoSmallBody'>{lead.requestDate}</p>
				</span>
				<span className='indInfoSpan'>
					<p className='infoSmallHead'>Date added</p>
					<p className='infoSmallBody'>{lead.dateAdded}</p>
				</span>
				<span className='indInfoSpan'>
					<p className='infoSmallHead'>Time in Group</p>
					<p className='infoSmallBody'>
						{lead.status === 'Approved'
							? moment().diff(
									moment(lead.dateAdded, 'MMMM Do YYYY').format('YYYY-MM-DD'),
									'days'
							  ) + ' days'
							: '---'}
					</p>
				</span>
			</div>
			<div className='profileLinkSec'>
				<p className='profileLinkHead'>Profile Link</p>
				<p className='profileLink'>
					<a href={lead.fbuser?.userID} target='_blank' rel='noreferrer'>
						{lead.fbuser?.userID}
					</a>
				</p>
			</div>
			<div className='profileLinkSec'>
				<p className='profileLinkHead'>Username</p>
				<p className='profileLink'>{lead.fbuser?.userName}</p>
			</div>
			<div className='profileLinkSec'>
				<p className='profileLinkHead'>Joined Facebook On</p>
				<p className='profileLink'>{lead.fbuser?.joinedDate}</p>
			</div>
			<div className='profileLinkSec'>
				<p className='profileLinkHead'>Status</p>
				<p className='profileLink'>{lead.status}</p>
			</div>
		</div>
	);
};

export default MemberBasicInfo;
